import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';

import { ReplaySubject } from 'rxjs';
import {
    BaseNestedFieldDefinition,
    FieldType
} from '../../../../../core/field-definitions/entities/field-definition.entity';
import { ExtendedBaseProfileField } from '../../../../../core/profiles/entities/extended-profile-field.entity';
import { PartialRecord } from '../../../../../core/records/entities/partial-record.class';
import { SimpleFieldValue } from '../../../../entities/field-values/field-type-values.entity';
import { FieldReadHelper } from '../../../../helpers/fields/field-read.helper';
import { ShSearchRoutingService } from '../../../../services/search-routing.service';
import { ShBaseGenericReadonlyFieldComponent } from '../../base-generic-readonly-field/base-generic-readonly-field.component';

@Component({
    standalone: false,
    selector: 'sh-labeled-url-readonly-field',
    templateUrl: './labeled-url-readonly-field.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['../../base-generic-readonly-field/base-generic-readonly-field.component.scss']
})
export class ShLabeledUrlReadonlyFieldComponent extends ShBaseGenericReadonlyFieldComponent implements OnDestroy {
    labelValue$: ReplaySubject<SimpleFieldValue | null> = new ReplaySubject<SimpleFieldValue | null>(1);
    urlValue$: ReplaySubject<SimpleFieldValue | null> = new ReplaySubject<SimpleFieldValue | null>(1);

    constructor(
        protected fieldHelper: FieldReadHelper,
        protected searchRoutingService: ShSearchRoutingService
    ) {
        super(searchRoutingService);
    }

    init(profileField: ExtendedBaseProfileField, fragment: PartialRecord): void {
        const urlField: BaseNestedFieldDefinition | undefined = profileField.FieldDefinition.Children?.find(
            def => def.Type === FieldType.UrlField
        );
        const labelField: BaseNestedFieldDefinition | undefined = profileField.FieldDefinition.Children?.find(
            def => def.Type === FieldType.SimpleField
        );

        if (!urlField || !labelField) {
            console.error(
                `LabeledUrlReadonlyFieldComponent (${profileField.DottedKey}): Missconfigured field-definitions for labeled-url control. MapField must contain a SimpleField and a UrlField.`
            );

            this.labelValue$.next(null);
            this.urlValue$.next(null);

            return;
        }

        const urlValue: SimpleFieldValue | null = this.fieldHelper.getSimpleFieldValue(urlField, fragment);
        const labelValue: SimpleFieldValue | null = this.fieldHelper.getSimpleFieldValue(labelField, fragment);

        this.urlValue$.next(urlValue);
        this.labelValue$.next(labelValue ?? urlValue ?? null);
    }

    ngOnDestroy(): void {
        this.urlValue$.complete();
        this.labelValue$.complete();

        super.ngOnDestroy();
    }
}
